import { Flex, Paragraph } from "@eworkit/iris";
import React from "react";
import { useTranslation } from "react-i18next";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";
import { AttachmentsList } from "@/views/consultant-profiles/details/attachments/AttachmentsList";
import { AttachmentsEdit } from "@/views/ConsultantProfiles/Detail/AttachmentsSection/AttachmentsForm";

interface AttachmentsSectionProps extends IConsultantProfileSectionProps, IEditableSectionRenderProps {}

export const AttachmentsSection: React.FC<AttachmentsSectionProps> = ({ editableProps, onUpdate, record }) => {
  const { t } = useTranslation("session");

  return (
    <Flex flexDirection="column" gap="md">
      <Paragraph size="p-xl" bold>
        {t("CONSULTANT_PROFILES.DETAIL.ATTACHMENTS.SECTION_HEADER")}
      </Paragraph>
      {editableProps.editMode ? (
        <AttachmentsEdit
          source={record}
          initialValues={{ attachments: record.attachments?.map(attachment => ({ attachment })) ?? [] }}
          onUpdate={onUpdate}
          onCancel={editableProps.handleCancelClick}
          editableProps={editableProps}
        />
      ) : (
        <AttachmentsList attachments={record.attachments} />
      )}
    </Flex>
  );
};
